export enum ClientType {
	company = 0,
	private = 1,
}

export interface Client {
	id: number;
	name: string;
	type: ClientType;
	lockedDate: Date | null;
	lockedBy: number | null;
	phone: string;
	email: string | null;
	nip: string | null;
	bdo: string | null;
	street: string | null;
	city: string | null;
	postal: string | null;
	description: string | null;
	createdDate: string;
	createdBy: number;
	removedDate: string | null;
	removedBy: number | null;
}
